<h2 mat-dialog-title>Usuário com acesso ao box</h2>
<form [formGroup]="insertUpdateFormBoxAccessUpdate" (ngSubmit)="setBoxAccessUser()">
  <mat-dialog-content>
    <div class="row center">
      <div class="col-xs-12">
        <div class="alert alert-info">
          <h3><strong>Importante</strong></h3>
          <ul>
            <li>Pode demorar algum tempo para esta alteraçāo se refletir no equipamento de controle de acesso ao seu box</li>
            <li>Em caso de dúvidas ou problemas de sincronização, entre em contato conosco.</li>
          </ul>
        </div>
      </div>
    </div>
    <p class="input-ocultar">
      <mat-form-field appearance="fill">
        <input matInput type="text" value="" formControlName="id">
      </mat-form-field>
    </p>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <mat-form-field appearance="fill">
          <mat-label>CPF</mat-label>
          <input matInput type="text" (blur)="loadUser()" maxlength="15" inputmode="numeric" required formControlName="cpf" mask="000.000.000-00">
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('cpf')?.hasError('required')">CPF não informado.</mat-error>
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('cpf')?.hasError('maxlength')">O CPF deve ter no máximo 15 caracteres.</mat-error>
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('cpf')?.hasError('cpf')">CPF inválido.</mat-error>
        </mat-form-field>
      </div>
      <div class="col-xs-12 col-md-8">
        <mat-form-field appearance="fill">
          <mat-label>Nome</mat-label>
          <input matInput type="text" (blur)="setDisplayName()" maxlength="60" required formControlName="nome">
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('nome')?.hasError('required')">Nome não informado.</mat-error>
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('nome')?.hasError('maxlength')">O nome deve ter no máximo 60 caracteres.</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <mat-form-field class="codigo-acesso" appearance="fill">
          <mat-label>Código de acesso</mat-label>
          <input matInput type="text" inputmode="numeric" maxlength="10" pattern="[0-9]*" required formControlName="codigoAcesso">
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('codigoAcesso')?.hasError('required')">Código de acesso não informado.</mat-error>
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('codigoAcesso')?.hasError('maxlength')">O código deve ter no máximo 10 caracteres.</mat-error>
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('codigoAcesso')?.hasError('pattern')">Use somente números.</mat-error>
        </mat-form-field>
      </div>
      <div class="col-xs-12 col-md-8">
        <mat-form-field appearance="fill">
          <mat-label>Nome no display</mat-label>
          <input matInput type="text" maxlength="20" required formControlName="nomeDisplay">
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('nomeDisplay')?.hasError('required')">Nome no display não informado.</mat-error>
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('nomeDisplay')?.hasError('maxlength')">O nome no display deve ter no máximo 20 caracteres.</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="fill">
          <mat-label>Observação</mat-label>
          <textarea matInput type="text" maxlength="80" formControlName="observacao"></textarea>
          <mat-error *ngIf="insertUpdateFormBoxAccessUpdate.get('observacao')?.hasError('maxlength')">A observação deve ter no máximo 80 caracteres.</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-3">
        <mat-slide-toggle color="primary" formControlName="liberado">
          Liberado
        </mat-slide-toggle>
      </div>
      <div class="col-xs-12 col-md-9">
        <span class="spn-btn-codigo-acesso">
          <button type="button" (click)="getAccessCode()" mat-stroked-button matTooltip="Gerar código de acesso aleatoriamente">Gerar novo código de acesso</button>
        </span>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="isSaving || isDeleting" mat-raised-button color="primary" >Gravar</button>
    <button type="button" (click)="openDialog()" *ngIf="isEditMode" [disabled]="isSaving || isDeleting" id="btn-delete-user" mat-stroked-button color="warn">Excluir</button>
  </mat-dialog-actions>
</form>
